import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import { styles } from '../../styles/form-styles';

class DomainSettings extends React.Component {
    render() {
      const { classes } = this.props;
      const containerClass = this.props.scale !== "auto" ? null : classes.hidden;
        return(
          <div className={containerClass}>
            <InputLabel className={classes.inputLabel} htmlFor="domain">Domain:</InputLabel>
            <div className={classes.domainSettingsInputsContainer}>
              <TextField
                id="min"
                label="Min"
                defaultValue={this.props.domainMin}
                helperText="max: 1.0"
                type="number"
                inputProps={{
                  name: "domainMin",
                  max: "1.0",
                  step: "0.1",
                  onBlur: this.props.onChange
                }}
                InputLabelProps={{
                shrink: true,
                }}
                margin="normal"
                className={classes.domainSettingsInputs}
              /> 
              <TextField
                id="max"
                label="Max"
                defaultValue={this.props.domainMax}
                type="number"
                inputProps={{
                  name: "domainMax",
                  onBlur: this.props.onChange
                }}
                InputLabelProps={{
                shrink: true,
                }}
                margin="normal"
                className={classes.domainSettingsInputs}
              />
            </div>           
          </div>
        )
    }   
}

DomainSettings.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(DomainSettings);


// WEBPACK FOOTER //
// ./src/components/Settings/DomainSettings.js